import api from "api";
import { useQuery } from "react-query";

const mediaApiBase = process.env.REACT_APP_API_URL_V2 + "/v2/support/media";
export const key = "getImages";

const useGetImages = (exercise_id?: number) => {
  return useQuery(key, () =>
    // @ts-ignore
    api.parse(`GET /exercises/images`, {
      root: mediaApiBase,
    })
  );
};

export default useGetImages;
